

export function Point_toPosition(p) {
    return {
        lat: p.Latitude,
        lng: p.Longitude,
    };
}

